// extracted by mini-css-extract-plugin
export default {"SecondBar":"SecondBar_SecondBar__hkkdt","Regular":"SecondBar_Regular__YmtAX","Tall":"SecondBar_Tall__WJ-D6"};